import type { useApp } from '@/hooks/use-app-context';
import type { FlushStop } from './outbox-flush';
import type { OutboxItem } from './outbox.types';

export type OfflineCopy = ReturnType<typeof useApp>['t']['offline'];

/** Why the server refused an item, in words: never the raw server code. */
export function failureReason(item: OutboxItem, copy: OfflineCopy): string {
  const status = item.lastError?.status;
  if (status === 400 || status === 422) return copy.reasonInvalid;
  if (status === 403) return copy.reasonForbidden;
  if (status === 404) return copy.reasonNotFound;
  if (status === 413) return copy.reasonTooLarge;
  return copy.reasonOther;
}

export const stopMessage = (stop: FlushStop | null, copy: OfflineCopy) =>
  stop === 'auth' ? copy.stopAuth : stop === 'gate' ? copy.stopGate : stop === 'server' ? copy.stopServer : stop === 'offline' ? copy.stopOffline : null;
